import { useEffect, useState } from "react";
import { Mail, Inbox } from "lucide-react";
import api from "@/lib/api";

export default function Messages() {
  const [msgs, setMsgs] = useState([]);
  const [active, setActive] = useState(null);

  const load = () => api.get("/admin/contact-messages").then((r) => setMsgs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const open = async (m) => {
    setActive(m);
    if (m.status === "new") { await api.put(`/admin/contact-messages/${m.id}/read`).catch(() => {}); load(); }
  };

  return (
    <div className="space-y-5">
      <div><h1 className="font-display text-2xl font-bold tracking-tight">Messages</h1><p className="text-sm text-zinc-500">Contact form submissions from customers</p></div>
      {msgs.length === 0 ? (
        <div className="bg-white border border-zinc-200 rounded-xl p-12 text-center text-zinc-400 text-sm flex flex-col items-center gap-3"><Inbox size={28} className="text-zinc-300" />No messages yet.</div>
      ) : (
        <div className="grid lg:grid-cols-5 gap-5">
          <div className="lg:col-span-2 bg-white border border-zinc-200 rounded-xl divide-y divide-zinc-100 overflow-hidden">
            {msgs.map((m) => (
              <button key={m.id} onClick={() => open(m)} className={`w-full text-left p-4 hover:bg-zinc-50 transition-colors ${active?.id === m.id ? "bg-zinc-50" : ""}`} data-testid={`message-${m.id}`}>
                <div className="flex items-center justify-between">
                  <span className="font-medium text-sm truncate">{m.name}</span>
                  {m.status === "new" && <span className="text-[10px] bg-[#FF6A1A] text-white px-2 py-0.5 rounded-full font-semibold">NEW</span>}
                </div>
                <p className="text-xs text-zinc-500 truncate mt-0.5">{m.subject || m.message}</p>
                <p className="text-[11px] text-zinc-400 mt-1">{new Date(m.created_at).toLocaleString()}</p>
              </button>
            ))}
          </div>
          <div className="lg:col-span-3 bg-white border border-zinc-200 rounded-xl p-6">
            {active ? (
              <div className="space-y-3" data-testid="message-detail">
                <h3 className="font-display text-xl font-bold">{active.subject || "(No subject)"}</h3>
                <div className="text-sm text-zinc-600 flex items-center gap-2"><Mail size={14} /><a href={`mailto:${active.email}`} className="text-blue-600 hover:underline">{active.email}</a> · {active.name}</div>
                <p className="text-xs text-zinc-400">{new Date(active.created_at).toLocaleString()}</p>
                <div className="border-t border-zinc-100 pt-4 text-sm text-zinc-700 whitespace-pre-wrap leading-relaxed">{active.message}</div>
              </div>
            ) : <p className="text-sm text-zinc-400">Select a message to read it.</p>}
          </div>
        </div>
      )}
    </div>
  );
}
